import { RavenInsertMeta } from 'library-@/services/sentry';
import _ from 'lodash';

const pnCountryReg = (function() {
    try {
        return new RegExp('^\\D+', 's');
    } catch (err) {
        return undefined;
    }
})();

const pnYearReg = (pbd) => {
    if (!pbd) {
        return '';
    }
    const time = new Date(pbd);
    return time.getFullYear();
};

const getPnType = (typeArr) => {
    const typeStr = _.findLast(typeArr, item => {
        return item && item.length === 3;
    });
    return typeStr && typeStr.substring(2);
};

export const setGlobalRvTrackAttr = (patentData, side) => {
    if (!window.rvTrack) return;
    const pn = patentData.PN;
    const pbd = patentData.PBD || false;
    const pnContry = (pn.match(pnCountryReg) || [])[0];
    const pnYear = pnYearReg(pbd);
    const pnType = getPnType(patentData.TYPE);
    const globalAttrs = { pn_country: pnContry, pn_year: pnYear, pn_type: pnType };
    if (side) {
        window.rvTrack.GlobalAttrs = window.rvTrack.GlobalAttrs || {};
        window.rvTrack.GlobalAttrs[`compare_${side}`] = globalAttrs;
    } else {
        window.rvTrack.GlobalAttrs = globalAttrs;
    }
};

// 对比视图需要根据id存取数据
export const initWindowRvTrack = () => {
    window.rvTrack = (action, attribute, moduleName = 'Patent View') => {
        if (RavenInsertMeta) {
            const attr = Object.assign(_.get(window, 'rvTrack.GlobalAttrs', {}), attribute || {});
            RavenInsertMeta(moduleName, action, attr);
        }
    };
    window.rvTrack.lp = (action, attribute) => {
        window.rvTrack(action, attribute, 'LifeScience In Patent View');
    };
};
